// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/Georama_SemiCondensed-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Georama:wght@400&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@400&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: "Georama SemiCondensed";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    font-weight: 400;
}

body {
    margin: auto;
    line-height: normal;
    font-family: var(--font-lato);
    font-size: 1rem;
    height: 100%;
    color: var(--secondary-color);
}

:root {
    /* fonts */
    --title: "Georama SemiCondensed";
    --font-lato: Lato;
    --navbar1: Georama;

    /* font sizes */
    --title-1-desktop-size: 3rem;
    --title-1-tablet-size: 2.5rem;
    --title-2-desktop-size: 2.2rem;
    --title-2-tablet-size: 1.6rem;
    --title-3-desktop-size: 1.75rem;
    --title-3-tablet-size: 1.375rem;
    --title-4-desktop-size: 1.5rem;
    --title-4-tablet-size: 1.19rem;
    --title-5-desktop-size: 1.25rem;
    --title-5-tablet-size: 1rem;

    /* Colors */
    --primary-color: #e40032;
    --secondary-color: #333f4c;
    --gray: #D9D9D9;
    --lightGray: #F7F6F7;
    --white: #fff;
    --info-color: #1581BF;
    --success-color: #8BC74E;
    --warning-color: #ECAA07;
    --pending-color: #e5e912;

    /* Gaps */
    --gap-md: 0.31rem;
    --gap-lg: 1rem;

    /* Paddings */
    --padding-sm: 1.38rem;
    --padding-md: 3rem;
}

.section {
    margin: auto;
    margin-top: 3rem;
}

.displayFlexCenter {
    display: flex;
    justify-content: center;
    align-items: center;
}

.spaceBetweenContainer {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.spaceBetweenContainerStart {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.flexWrap {
    display: flex;
    flex-wrap: wrap;
}

.flexWrapStart {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
}

.flexWrapSpaceBetween {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.flexColumnContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.flexColumnContainerAlignStart {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
}

.userCard {
    width: 70%;
    margin: 0 auto;
    padding: 2rem;
    border-radius: 0.5rem;
    box-shadow: 0 0 1rem rgba(0, 0, 0, 0.2);
}

.cardBody {
    padding-top: 2rem;
}

.formContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 1.5rem;
}

.mediumContainer {
    width: 48%;
}

.largeContainer {
    width: 90%;
}

.badgeContainer {
    width: 11rem;
}

.select {
    margin-bottom: 1rem;
}

textarea,
p {
    text-align: justify;
}

.link {
    margin-top: 2rem;
}

.actionIcon {
    margin-right: 0.5rem;
    cursor: pointer;
}

.actionIcon:hover {
    color: var(--primary-color);
}

.button {
    width: 8.75rem;
    cursor: pointer;
    margin: 2rem 2rem 1rem 0;
}

.fit {
    width: -moz-fit-content;
    width: fit-content;
}

.largeButton {
    width: 90%;
    margin-top: 2rem;
}

.message {
    display: none;
    color: var(--primary-color);
}

.footerContainer {
    bottom: 0;
    position: absolute;
    width: 100%;
}

/* ========================================================= */
/* ==============   STUDY INSTANCE GRID     ================= */
/* ========================================================= */

/**
 * Grille responsive pour afficher les InstanceCard.
 * Utilisée par StudyDefinitionInstances.tsx sur la div .instances-grid
 *
 * auto-fit/minmax = remplit toute la largeur, sans créer un "trou blanc"
 * sur la droite comme avec flex + max-width.
 */
.instances-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(320px, 100%), 1fr));
    gap: 1.5rem;
    align-items: stretch;
    width: 100%;
}

/* ========================================================= */
/* ==================   INSTANCE CARD   ==================== */
/* ========================================================= */

.instance-card {
    display: flex;
    flex-direction: column;
    background-color: var(--white);
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.07);
    padding: 1rem 1rem 0.75rem;
    transition: box-shadow 0.2s ease, transform 0.2s ease;
    height: 100%;
}

.instance-card:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.12);
    transform: translateY(-2px);
}

.instance-card-title-container {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
}

.instance-card-title {
    font-size: 1.2rem;
    font-weight: 600;
    color: var(--secondary-color);
    margin: 0;
    line-height: 1.3;
    word-break: break-word;
}

.instance-card-content {
    flex-grow: 1;
    margin-bottom: 0.75rem;
}

.instance-card-description {
    color: #555;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;

    /* 4 lignes visibles */
    -webkit-line-clamp: 4;
    line-clamp: 4;
    -webkit-box-orient: vertical;
}

/* Footer (bouton) */
.instance-card-footer {
    display: flex;
    justify-content: flex-start;
    margin-top: auto;
    padding-top: 0.5rem;
    border-top: 1px solid #eee;
}

/* Bouton "Voir l'instance" */
.instance-card-button {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    background-color: var(--primary-color);
    border-color: var(--primary-color);
    font-weight: 600;
    cursor: pointer;
}

.instance-card-button svg {
    font-size: 0.9rem;
}

/* ========================================================= */
/* ==================   PHASE BADGES   ===================== */
/* ========================================================= */

/**
 * Base badge
 */
.instance-card-phase-badge {
    display: inline-block;
    padding: 0.25rem 0.5rem;
    border-radius: 12px;
    font-size: 0.8rem;
    font-weight: 600;
    line-height: 1.2;
    white-space: nowrap;
    text-transform: none;
}

.instance-card-phase-initial {
    background-color: var(--success-color);
    color: #E3F2FD;
}

.instance-card-phase-post-cohorting {
    background-color: var(--info-color);
    color: #E8F5E9;
}

.instance-card-phase-post-datamart {
    background-color: var(--warning-color);
    color: #FFF3E0;
}

/* ============================================ */
/* ========   HEADER + FILTER TOOLBAR   ======= */
/* ============================================ */

.instances-section {
    width: 100%;
    max-width: 1400px;
    margin: 0 auto;
    padding: 1rem 1.5rem 2rem;
}

.instances-header {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-bottom: 1.5rem;
}

/* Titre + (futur bouton créer) */
.instances-header-top {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
}

.instances-page-title {
    font-family: var(--title);
    font-size: 1.5rem;
    line-height: 1.3;
    color: var(--secondary-color);
    margin: 0;
}

/* Ligne des filtres */
.instances-filters-row {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 1rem;
}

/* Un groupe filtre = label + select */
.filter-group {
    display: flex;
    flex-direction: column;
}

.filter-label {
    font-size: 0.8rem;
    font-weight: 600;
    color: var(--secondary-color);
    margin-bottom: 0.25rem;
}

.filter-select {
    min-width: 180px;
    padding: 0.5rem 0.75rem;
    border-radius: 6px;
    border: 1px solid #ccc;
    background-color: #fff;
    font-size: 0.9rem;
    line-height: 1.2;
    color: var(--secondary-color);
}
.filter-select:focus {
    outline: 2px solid var(--primary-color);
    outline-offset: 0;
    border-color: var(--primary-color);
}


/* ============================= */
/*    ADD INSTANCE ("+") CARD    */
/* ============================= */

.add-instance-card {
    display: flex;
    align-items: center;
    justify-content: center;

    /* reset bouton par défaut */
    background-color: transparent;
    border: 2px dashed var(--primary-color);
    color: var(--primary-color);
    font: inherit;
    padding: 1rem;
    min-height: 160px;
    width: 100%;
    text-align: center;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.03);

    cursor: pointer;
    transition: box-shadow 0.2s ease, transform 0.2s ease,
                background-color 0.2s ease;
}

/* enlever le focus moche natif mais garder accessibilité */
.add-instance-card:focus {
    outline: 2px solid var(--primary-color);
    outline-offset: 2px;
}

.add-instance-card:hover {
    background-color: rgba(228, 0, 50, 0.03); /* rouge translucide */
    box-shadow: 0 4px 12px rgba(0,0,0,0.12);
    transform: translateY(-2px);
}

.add-instance-card-full {
    grid-column: 1 / -1; /* si un jour tu veux la faire prendre toute la ligne */
}

.add-instance-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;

    color: var(--primary-color);
}

.add-instance-icon {
    font-size: 2rem;
    line-height: 1;
    font-weight: 600;
    color: var(--primary-color);
}

.add-instance-label {
    font-size: 0.95rem;
    font-weight: 600;
    margin: 0;
    color: var(--primary-color);
    text-align: center;
}


/* ============================= */
/*  HEADER LAYOUT (pas inline)  */
/* ============================= */

.instances-header-left {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    flex: 1 1 auto;
    min-width: 0;
}

.instances-header-title-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5rem;
}

.instances-page-title-no-margin {
    margin: 0;
}

/* description de la définition (en haut de page) */
.instances-definition-desc-text {
    margin: 0;
    max-width: 60rem;
    color: #555;
    font-size: 0.95rem;
    line-height: 1.4;
    text-align: justify;
}

/* filtre row spacing */
.instances-filters-row-marginTop {
    margin-top: 1rem;
}

/* message "aucune instance trouvée" sans inline */
.instances-empty-hint {
    color: #666;
    font-size: 0.9rem;
    margin-top: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAGA;IACI,oCAAoC;IACpC,4CAAuD;IACvD,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,6BAA6B;IAC7B,eAAe;IACf,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,gCAAgC;IAChC,iBAAiB;IACjB,kBAAkB;;IAElB,eAAe;IACf,4BAA4B;IAC5B,6BAA6B;IAC7B,8BAA8B;IAC9B,6BAA6B;IAC7B,+BAA+B;IAC/B,+BAA+B;IAC/B,8BAA8B;IAC9B,8BAA8B;IAC9B,+BAA+B;IAC/B,2BAA2B;;IAE3B,WAAW;IACX,wBAAwB;IACxB,0BAA0B;IAC1B,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb,qBAAqB;IACrB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;;IAExB,SAAS;IACT,iBAAiB;IACjB,cAAc;;IAEd,aAAa;IACb,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,cAAc;IACd,aAAa;IACb,qBAAqB;IACrB,uCAAuC;AAC3C;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,uBAAkB;IAAlB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,WAAW;AACf;;AAEA,8DAA8D;AAC9D,+DAA+D;AAC/D,8DAA8D;;AAE9D;;;;;;EAME;AACF;IACI,aAAa;IACb,sEAAsE;IACtE,WAAW;IACX,oBAAoB;IACpB,WAAW;AACf;;AAEA,8DAA8D;AAC9D,8DAA8D;AAC9D,8DAA8D;;AAE9D;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,sBAAsB;IACtB,kBAAkB;IAClB,sCAAsC;IACtC,0BAA0B;IAC1B,qDAAqD;IACrD,YAAY;AAChB;;AAEA;IACI,uCAAuC;IACvC,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;IAC7B,SAAS;IACT,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,SAAS;IACT,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;;IAEpB,sBAAsB;IACtB,qBAAqB;IACrB,aAAa;IACb,4BAA4B;AAChC;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,2BAA2B;IAC3B,gBAAgB;IAChB,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA,6BAA6B;AAC7B;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,sCAAsC;IACtC,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,8DAA8D;AAC9D,8DAA8D;AAC9D,8DAA8D;;AAE9D;;EAEE;AACF;IACI,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,sCAAsC;IACtC,cAAc;AAClB;;AAEA,iDAAiD;AACjD,iDAAiD;AACjD,iDAAiD;;AAEjD;IACI,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,qBAAqB;AACzB;;AAEA,iCAAiC;AACjC;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;IAC7B,SAAS;AACb;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,SAAS;AACb;;AAEA,sCAAsC;AACtC;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;AACjC;AACA;IACI,uCAAuC;IACvC,iBAAiB;IACjB,kCAAkC;AACtC;;;AAGA,kCAAkC;AAClC,kCAAkC;AAClC,kCAAkC;;AAElC;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,4BAA4B;IAC5B,6BAA6B;IAC7B,uCAAuC;IACvC,2BAA2B;IAC3B,aAAa;IACb,aAAa;IACb,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,sCAAsC;;IAEtC,eAAe;IACf;0CACsC;AAC1C;;AAEA,2DAA2D;AAC3D;IACI,uCAAuC;IACvC,mBAAmB;AACvB;;AAEA;IACI,wCAAwC,EAAE,sBAAsB;IAChE,uCAAuC;IACvC,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB,EAAE,uDAAuD;AAChF;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;;IAEX,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,2BAA2B;IAC3B,kBAAkB;AACtB;;;AAGA,kCAAkC;AAClC,iCAAiC;AACjC,kCAAkC;;AAElC;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,SAAS;AACb;;AAEA,mDAAmD;AACnD;IACI,SAAS;IACT,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,uBAAuB;AACvB;IACI,gBAAgB;AACpB;;AAEA,kDAAkD;AAClD;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;AACpB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Georama:wght@400&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Lato:wght@400&display=swap\");\n\n@font-face {\n    font-family: \"Georama SemiCondensed\";\n    src: url(\"../public/Georama_SemiCondensed-Regular.ttf\");\n    font-weight: 400;\n}\n\nbody {\n    margin: auto;\n    line-height: normal;\n    font-family: var(--font-lato);\n    font-size: 1rem;\n    height: 100%;\n    color: var(--secondary-color);\n}\n\n:root {\n    /* fonts */\n    --title: \"Georama SemiCondensed\";\n    --font-lato: Lato;\n    --navbar1: Georama;\n\n    /* font sizes */\n    --title-1-desktop-size: 3rem;\n    --title-1-tablet-size: 2.5rem;\n    --title-2-desktop-size: 2.2rem;\n    --title-2-tablet-size: 1.6rem;\n    --title-3-desktop-size: 1.75rem;\n    --title-3-tablet-size: 1.375rem;\n    --title-4-desktop-size: 1.5rem;\n    --title-4-tablet-size: 1.19rem;\n    --title-5-desktop-size: 1.25rem;\n    --title-5-tablet-size: 1rem;\n\n    /* Colors */\n    --primary-color: #e40032;\n    --secondary-color: #333f4c;\n    --gray: #D9D9D9;\n    --lightGray: #F7F6F7;\n    --white: #fff;\n    --info-color: #1581BF;\n    --success-color: #8BC74E;\n    --warning-color: #ECAA07;\n    --pending-color: #e5e912;\n\n    /* Gaps */\n    --gap-md: 0.31rem;\n    --gap-lg: 1rem;\n\n    /* Paddings */\n    --padding-sm: 1.38rem;\n    --padding-md: 3rem;\n}\n\n.section {\n    margin: auto;\n    margin-top: 3rem;\n}\n\n.displayFlexCenter {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.spaceBetweenContainer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.spaceBetweenContainerStart {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n}\n\n.flexWrap {\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.flexWrapStart {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n}\n\n.flexWrapSpaceBetween {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n}\n\n.flexColumnContainer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n}\n\n.flexColumnContainerAlignStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n    flex-direction: column;\n}\n\n.userCard {\n    width: 70%;\n    margin: 0 auto;\n    padding: 2rem;\n    border-radius: 0.5rem;\n    box-shadow: 0 0 1rem rgba(0, 0, 0, 0.2);\n}\n\n.cardBody {\n    padding-top: 2rem;\n}\n\n.formContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 1.5rem;\n}\n\n.mediumContainer {\n    width: 48%;\n}\n\n.largeContainer {\n    width: 90%;\n}\n\n.badgeContainer {\n    width: 11rem;\n}\n\n.select {\n    margin-bottom: 1rem;\n}\n\ntextarea,\np {\n    text-align: justify;\n}\n\n.link {\n    margin-top: 2rem;\n}\n\n.actionIcon {\n    margin-right: 0.5rem;\n    cursor: pointer;\n}\n\n.actionIcon:hover {\n    color: var(--primary-color);\n}\n\n.button {\n    width: 8.75rem;\n    cursor: pointer;\n    margin: 2rem 2rem 1rem 0;\n}\n\n.fit {\n    width: fit-content;\n}\n\n.largeButton {\n    width: 90%;\n    margin-top: 2rem;\n}\n\n.message {\n    display: none;\n    color: var(--primary-color);\n}\n\n.footerContainer {\n    bottom: 0;\n    position: absolute;\n    width: 100%;\n}\n\n/* ========================================================= */\n/* ==============   STUDY INSTANCE GRID     ================= */\n/* ========================================================= */\n\n/**\n * Grille responsive pour afficher les InstanceCard.\n * Utilisée par StudyDefinitionInstances.tsx sur la div .instances-grid\n *\n * auto-fit/minmax = remplit toute la largeur, sans créer un \"trou blanc\"\n * sur la droite comme avec flex + max-width.\n */\n.instances-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(min(320px, 100%), 1fr));\n    gap: 1.5rem;\n    align-items: stretch;\n    width: 100%;\n}\n\n/* ========================================================= */\n/* ==================   INSTANCE CARD   ==================== */\n/* ========================================================= */\n\n.instance-card {\n    display: flex;\n    flex-direction: column;\n    background-color: var(--white);\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.07);\n    padding: 1rem 1rem 0.75rem;\n    transition: box-shadow 0.2s ease, transform 0.2s ease;\n    height: 100%;\n}\n\n.instance-card:hover {\n    box-shadow: 0 4px 12px rgba(0,0,0,0.12);\n    transform: translateY(-2px);\n}\n\n.instance-card-title-container {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 0.5rem;\n    margin-bottom: 0.5rem;\n}\n\n.instance-card-title {\n    font-size: 1.2rem;\n    font-weight: 600;\n    color: var(--secondary-color);\n    margin: 0;\n    line-height: 1.3;\n    word-break: break-word;\n}\n\n.instance-card-content {\n    flex-grow: 1;\n    margin-bottom: 0.75rem;\n}\n\n.instance-card-description {\n    color: #555;\n    margin: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n\n    /* 4 lignes visibles */\n    -webkit-line-clamp: 4;\n    line-clamp: 4;\n    -webkit-box-orient: vertical;\n}\n\n/* Footer (bouton) */\n.instance-card-footer {\n    display: flex;\n    justify-content: flex-start;\n    margin-top: auto;\n    padding-top: 0.5rem;\n    border-top: 1px solid #eee;\n}\n\n/* Bouton \"Voir l'instance\" */\n.instance-card-button {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n    background-color: var(--primary-color);\n    border-color: var(--primary-color);\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.instance-card-button svg {\n    font-size: 0.9rem;\n}\n\n/* ========================================================= */\n/* ==================   PHASE BADGES   ===================== */\n/* ========================================================= */\n\n/**\n * Base badge\n */\n.instance-card-phase-badge {\n    display: inline-block;\n    padding: 0.25rem 0.5rem;\n    border-radius: 12px;\n    font-size: 0.8rem;\n    font-weight: 600;\n    line-height: 1.2;\n    white-space: nowrap;\n    text-transform: none;\n}\n\n.instance-card-phase-initial {\n    background-color: var(--success-color);\n    color: #E3F2FD;\n}\n\n.instance-card-phase-post-cohorting {\n    background-color: var(--info-color);\n    color: #E8F5E9;\n}\n\n.instance-card-phase-post-datamart {\n    background-color: var(--warning-color);\n    color: #FFF3E0;\n}\n\n/* ============================================ */\n/* ========   HEADER + FILTER TOOLBAR   ======= */\n/* ============================================ */\n\n.instances-section {\n    width: 100%;\n    max-width: 1400px;\n    margin: 0 auto;\n    padding: 1rem 1.5rem 2rem;\n}\n\n.instances-header {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    margin-bottom: 1.5rem;\n}\n\n/* Titre + (futur bouton créer) */\n.instances-header-top {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 1rem;\n}\n\n.instances-page-title {\n    font-family: var(--title);\n    font-size: 1.5rem;\n    line-height: 1.3;\n    color: var(--secondary-color);\n    margin: 0;\n}\n\n/* Ligne des filtres */\n.instances-filters-row {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-end;\n    gap: 1rem;\n}\n\n/* Un groupe filtre = label + select */\n.filter-group {\n    display: flex;\n    flex-direction: column;\n}\n\n.filter-label {\n    font-size: 0.8rem;\n    font-weight: 600;\n    color: var(--secondary-color);\n    margin-bottom: 0.25rem;\n}\n\n.filter-select {\n    min-width: 180px;\n    padding: 0.5rem 0.75rem;\n    border-radius: 6px;\n    border: 1px solid #ccc;\n    background-color: #fff;\n    font-size: 0.9rem;\n    line-height: 1.2;\n    color: var(--secondary-color);\n}\n.filter-select:focus {\n    outline: 2px solid var(--primary-color);\n    outline-offset: 0;\n    border-color: var(--primary-color);\n}\n\n\n/* ============================= */\n/*    ADD INSTANCE (\"+\") CARD    */\n/* ============================= */\n\n.add-instance-card {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    /* reset bouton par défaut */\n    background-color: transparent;\n    border: 2px dashed var(--primary-color);\n    color: var(--primary-color);\n    font: inherit;\n    padding: 1rem;\n    min-height: 160px;\n    width: 100%;\n    text-align: center;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.03);\n\n    cursor: pointer;\n    transition: box-shadow 0.2s ease, transform 0.2s ease,\n                background-color 0.2s ease;\n}\n\n/* enlever le focus moche natif mais garder accessibilité */\n.add-instance-card:focus {\n    outline: 2px solid var(--primary-color);\n    outline-offset: 2px;\n}\n\n.add-instance-card:hover {\n    background-color: rgba(228, 0, 50, 0.03); /* rouge translucide */\n    box-shadow: 0 4px 12px rgba(0,0,0,0.12);\n    transform: translateY(-2px);\n}\n\n.add-instance-card-full {\n    grid-column: 1 / -1; /* si un jour tu veux la faire prendre toute la ligne */\n}\n\n.add-instance-inner {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 0.5rem;\n\n    color: var(--primary-color);\n}\n\n.add-instance-icon {\n    font-size: 2rem;\n    line-height: 1;\n    font-weight: 600;\n    color: var(--primary-color);\n}\n\n.add-instance-label {\n    font-size: 0.95rem;\n    font-weight: 600;\n    margin: 0;\n    color: var(--primary-color);\n    text-align: center;\n}\n\n\n/* ============================= */\n/*  HEADER LAYOUT (pas inline)  */\n/* ============================= */\n\n.instances-header-left {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    flex: 1 1 auto;\n    min-width: 0;\n}\n\n.instances-header-title-row {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.instances-page-title-no-margin {\n    margin: 0;\n}\n\n/* description de la définition (en haut de page) */\n.instances-definition-desc-text {\n    margin: 0;\n    max-width: 60rem;\n    color: #555;\n    font-size: 0.95rem;\n    line-height: 1.4;\n    text-align: justify;\n}\n\n/* filtre row spacing */\n.instances-filters-row-marginTop {\n    margin-top: 1rem;\n}\n\n/* message \"aucune instance trouvée\" sans inline */\n.instances-empty-hint {\n    color: #666;\n    font-size: 0.9rem;\n    margin-top: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
